import React, { useState } from 'react'
import { useEffect } from 'react';
import ReactDatePicker from "react-datepicker";
import { Button } from "../../common/Button/Button";
import api from "../../utils/api";
import EngagedAnnualTurnover from './EngagedAnnualTurnover'
import EngagedPartner from './EngagedPartner'
import EUGrid from './EUGrid'
import EUSourceAndMedimGrid from './EUSourceAndMedimGrid'
import FirstTimeAnnualTurnover from './FirstTimeAnnualTurnover'
import FirstTimePartner from './FirstTimePartner'
import FTUGrid from './FTUGrid'
import FTUSourceAndMediumGrid from './FTUSourceAndMediumGrid'
import MonthlyDataGrid from './MonthlyDataGrid'
import MonthlyUserChart from './MonthlyUserChart'
import TotalEngagedUserChart from './TotalEngagedUserChart'
import TotalFirstTimeChart from './TotalFirstTimeChart'
import TotalResourceAwailed from './TotalResourceAwailed'
import { toast } from 'react-toastify';
import Modal from "react-modal";
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg'
import ic_filter from '../../assets/ic_filter.svg'
import FirstTimeProgram from './FirstTimeProgram';
import EngagedUserProgram from './EngagedUserProgram';
import DynamicProgramTable from './DynamicProgramTable';
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import PartnerDataTable from './PartnerDataTable';
import Spinner from '../../common/Spinner/Spinner';
import MergedPartnerTable from './MergedPartnerTable';
import MergedProgramTable from './MergedProgramTable';
import MergedResourceTable from './MergedResourceTable';
import MergedTurnoverTable from './MergedTurnoverTable';
import MergedPartnerResourceTable from './MergedPartnerResourceTable';
import MergedSourceMediumTable from './MergedSourceMediumTable';
import MergedProgramResourceTable from './MergedProgramResourceTable';
import ProgramManagerHome from './ProgramManagerHome';



const NewAndEngagedUserHome = () => {

    const [countData, setCountData] = useState({
        engaged_users: 0,
        first_time_users: 0
    })
    const [resourceCount, setResourceCount] = useState({
        record_engaged_users: 0,
        first_time_users: 0,
        total: 0
    })


    const FirstTimeAdditionalCount = 108840
    const EngagedUserAdditionalCount = 55586

    const TotalFirstTimeUserCount = countData.first_time_users + FirstTimeAdditionalCount;
    const TotalEngagedUserCount = countData.engaged_users + EngagedUserAdditionalCount
    const TotalResourceAvailedCount = resourceCount.total + FirstTimeAdditionalCount + EngagedUserAdditionalCount

    const [fromDate, setfromDate] = useState();
    const [toDate, settoDate] = useState();
    const [ftuGridData, setFtuGridData] = useState([])
    const [euGridData, setEuGridData] = useState([])
    const [firstTimePartnerData, setFirstTimePartnerData] = useState([])
    const [engagedPartnerData, setEngagedPartner] = useState([])
    const [firstTimeAnnualTurnoverData, setFirstTimeAnnualTurnoverData] = useState([])
    const [engagedAnnualTurnoverData, setEngagedAnnualTurnoverData] = useState([])
    const [ftuSourceAndMediumData, setFtuSourceAndMediumData] = useState([])
    const [engagedSourceAndMediumData, setEngagedSourceAndMediumData] = useState([])
    const [monthwiseData, setMonthwiseData] = useState([])
    const [firstTimePartnerResourceData, setFirstTimePartnerResourceData] = useState([])
    const [engagedPartnerResourceData, setEngagedPartnerResourceData] = useState([])
    const [firstTimeProgramResourceData, setFirstTimeProgramResourceData] = useState([])
    const [engagedProgramResourceData, setEngagedProgramResourceData] = useState([])
    const [firstTimeChartData, setFirstTimeChartData] = useState([])
    const [engagedChartData, setEngagedChartData] = useState([])
    const [resourceAwailedChartData, setResourceAwailedChartData] = useState([])
    const [firstTimeProgramData, setFirstTimeProgramData] = useState([])
    const [engagedUserProgramData, setEngagedUserProgramData] = useState([])
    const [firstTimeProgramName, setFirstTimeProgramName] = useState([])
    const [engagedProgramName, setEngagedProgramName] = useState([])
    const [newModal, setNewModal] = useState(false)
    const [partnerListdata, setPartnerListData] = useState([])
    const [programListdata, setProgramListData] = useState([])
    const [sourceListData, setSourceListData] = useState([])
    const [mediumListData, setMediumListData] = useState([])
    const [rawSourceMediumData, setRawSourceMediumData] = useState([])
    const [sourceListDataEu, setSourceListDataEu] = useState([])
    const [mediumListDataEu, setMediumListDataEu] = useState([])
    const [rawSourceMediumDataEu, setRawSourceMediumDataEu] = useState([])

    const [ftuPartnerListData, setFtuPartnerListData] = useState([])
    const [EuPartnerListData, setEuPartnerListData] = useState([])
    const [rawFtuPartnerData, setRawFtuPartnerData] = useState([])
    const [rawEuPartnerData, setRawEuPartnerData] = useState([])
    const [selectedOptionsFtuPartner, setSelectedOptionsFtuPartner] = useState([]);
    const [selectedOptionsEuPartner, setSelectedOptionsEuPartner] = useState([]);
    const [ftuPartnerModal, setFtuPartnerModal] = useState(false)
    const [euPartnerModal, setEuPartnerModal] = useState(false)

    const [ftuResourceListData, setFtuResourceListData] = useState([])
    const [EuResourceListData, setEuResourceListData] = useState([])
    const [rawFtuResourceData, setRawFtuResourceData] = useState([])
    const [rawEuResourceData, setRawEuResourceData] = useState([])
    const [selectedOptionsFtuResource, setSelectedOptionsFtuResource] = useState([]);
    const [selectedOptionsEuResource, setSelectedOptionsEuResource] = useState([]);
    const [ftuResourceModal, setFtuResourceModal] = useState(false)
    const [euResourceModal, setEuResourceModal] = useState(false)

    const [ftuProgramListData, setFtuProgramListData] = useState([])
    const [EuProgramListData, setEuProgramListData] = useState([])
    const [rawFtuProgramData, setRawFtuProgramData] = useState([])
    const [rawEuProgramData, setRawEuProgramData] = useState([])
    const [selectedOptionsFtuProgram, setSelectedOptionsFtuProgram] = useState([]);
    const [selectedOptionsEuProgram, setSelectedOptionsEuProgram] = useState([]);
    const [ftuProgramModal, setFtuProgramModal] = useState(false)
    const [euProgramModal, setEuProgramModal] = useState(false)

    const [partnerTableData, setPartnerTableData] = useState([])
    const [programTableData, setProgramTableData] = useState([])

    const [selectedOptions, setSelectedOptions] = useState([]);
    const partnerListUpdated = []

    const [selectedOptionsProgram, setSelectedOptionsProgram] = useState([])
    const programListUpdated = []

    const [selectedOptionsSource, setSelectedOptionsSource] = useState([]);
    const sourceListUpdated = []

    const [selectedOptionsMedium, setSelectedOptionsMedium] = useState([]);
    const mediumListUpdated = []

    const [selectedOptionsSourceEu, setSelectedOptionsSourceEu] = useState([]);

    const [selectedOptionsMediumEu, setSelectedOptionsMediumEu] = useState([]);

    
    const [isPartnerData, setIsPartnerData] = useState(false)
    const [isProgramData, setIsProgramData] = useState(false)

    // Source and Medium Model

    const [sourceModel, setSourceModel] = useState(false)
    const [sourceModelEu, setSourceModelEu] = useState(false)

    const [selectedOptionsMergedPartner, setSelectedOptionsMergedPartner] = useState([]);
    const [selectedOptionsMergedProgram, setSelectedOptionsMergedProgram] = useState([]);
    const [selectedOptionsMergedResource, setSelectedOptionsMergedResource] = useState([]);
    const [selectedOptionsMergedPartnerResource, setSelectedOptionsMergedPartnerResource] = useState([]);
    const [selectedOptionsMergedPartnerResourceEu, setSelectedOptionsMergedPartnerResourceEu] = useState([]);
    const [selectedOptionsMergedProgramResource, setSelectedOptionsMergedProgramResource] = useState([]);
    const [selectedOptionsMergedProgramResourceEu, setSelectedOptionsMergedProgramResourceEu] = useState([]);
    const [selectedOptionsMergedSourceMedium, setSelectedOptionsMergedSourceMedium] = useState([]);
    const [selectedOptionsMergedSourceMediumEu, setSelectedOptionsMergedSourceMediumEu] = useState([]);

    // Program Manager States

    const [isProgramManagerDashboard, setIsProgramManagerDashboard] = useState(false)
    const [partnerDataProgramManager, setPartnerDataProgramManager] = useState([])
    const [resourceDataSelectedPartner, setResourceDataSelectedPartner] = useState([])
    const [selectedProgramManager, setSelectedProgramManager] = useState([])
    const [selectedPartnerName, setSelectedPartnerName] = useState('')
    const [programDataManager, setProgramDataManager] = useState([])
    const [partnerDataForSelectedProgram, setPartnerDataForSelectedProgram] = useState([])
    const [selectedProgramName, setSelectedProgramName] = useState('')


    const handleSelect = (selected) => {
        setSelectedOptions(selected);
    };

    const handleSelectSource = (selected) => {
        setSelectedOptionsSource(selected)
    }

    useEffect(() => {
        if(selectedOptionsSource.length > 0){
            const filteredData = rawSourceMediumData.filter(obj => selectedOptionsSource.some(item => item.value === obj.sourse_name));
        console.log("Filt Data",filteredData);
        let arr1 = [] 
        filteredData.map((ele) => {
          if(ele.medium_name != "" && ele.medium_name != null) {
            arr1.push(ele.medium_name)
          }  
        });
        setMediumListData(arr1);
        } else {
            const mediumNames = rawSourceMediumData.reduce((uniqueNames, row) => {
                if (row.medium_name && (row.medium_name != null && row.medium_name != "") && !uniqueNames.includes(row.medium_name)) {
                  uniqueNames.push(row.medium_name);
                }
                return uniqueNames;
              }, []);
              setMediumListData(mediumNames)
        }
      }, [selectedOptionsSource, rawSourceMediumData]);

    const handleSelectMedium = (selected) => {
        setSelectedOptionsMedium(selected)
    }

    useEffect(() => {
        if(selectedOptionsMedium.length > 0){
            const filteredData1 = rawSourceMediumData.filter(obj => selectedOptionsMedium.some(item => item.value === obj.medium_name));
            console.log("Filt Data",filteredData1);
        let arr2 = [] 
        filteredData1.map((ele) => {
          if(ele.sourse_name != "" && ele.sourse_name != null) {
            arr2.push(ele.sourse_name)
          }  
        });
        setSourceListData(arr2);
        } else {
            const sourceNames = rawSourceMediumData.reduce((uniqueNames, row) => {
                if (row.sourse_name && (row.sourse_name != null && row.sourse_name != "") && !uniqueNames.includes(row.sourse_name)) {
                  uniqueNames.push(row.sourse_name);
                }
                return uniqueNames;
              }, []);
              setSourceListData(sourceNames)
        }
      }, [selectedOptionsMedium, rawSourceMediumData]);

    const handleSelectSourceEu = (selected) => {
        setSelectedOptionsSourceEu(selected)
    }

    useEffect(() => {
        if(selectedOptionsSourceEu.length > 0){
            const filteredData = rawSourceMediumDataEu.filter(obj => selectedOptionsSourceEu.some(item => item.value === obj.sourse_name));
        console.log("Filt Data",filteredData);
        let arr3 = [] 
        filteredData.map((ele) => {
          if(ele.medium_name != "" && ele.medium_name != null) {
            arr3.push(ele.medium_name)
          }  
        });
        setMediumListDataEu(arr3);
        } else {
            const mediumNames = rawSourceMediumDataEu.reduce((uniqueNames, row) => {
                if (row.medium_name && (row.medium_name != null && row.medium_name != "") && !uniqueNames.includes(row.medium_name)) {
                  uniqueNames.push(row.medium_name);
                }
                return uniqueNames;
              }, []);
              setMediumListDataEu(mediumNames)
        }
      }, [selectedOptionsSourceEu, rawSourceMediumDataEu]);

    const handleSelectMediumEu = (selected) => {
        setSelectedOptionsMediumEu(selected)
    }

    useEffect(() => {
        if(selectedOptionsMediumEu.length > 0){
            const filteredData1 = rawSourceMediumDataEu.filter(obj => selectedOptionsMediumEu.some(item => item.value === obj.medium_name));
            console.log("Filt Data",filteredData1);
        let arr2 = [] 
        filteredData1.map((ele) => {
          if(ele.sourse_name != "" && ele.sourse_name != null) {
            arr2.push(ele.sourse_name)
          }  
        });
        setSourceListDataEu(arr2);
        } else {
            const sourceNames = rawSourceMediumDataEu.reduce((uniqueNames, row) => {
                if (row.sourse_name && (row.sourse_name != null && row.sourse_name != "") && !uniqueNames.includes(row.sourse_name)) {
                  uniqueNames.push(row.sourse_name);
                }
                return uniqueNames;
              }, []);
              setSourceListDataEu(sourceNames)
        }
      }, [selectedOptionsMediumEu, rawSourceMediumDataEu]);

    const handleSelectProgram = (selected) => {
        setSelectedOptionsProgram(selected);
    };

    const handleFtuPartnerSelect = (selected) => {
        setSelectedOptionsFtuPartner(selected)
    }

    const handleEuPartnerSelect = (selected) => {
        setSelectedOptionsEuPartner(selected)
    }

    const handleFtuResourceSelect = (selected) => {
        setSelectedOptionsFtuResource(selected)
    }

    const handleEuResourceSelect = (selected) => {
        setSelectedOptionsEuResource(selected)
    }

    const handleFtuProgramSelect = (selected) => {
        setSelectedOptionsFtuProgram(selected)
    }

    const handleEuProgramSelect = (selected) => {
        setSelectedOptionsEuProgram(selected)
    }

    const openFilterModalisTrue = () => {
        setNewModal(true)
    }

    const openFilterModalisFalse = () => {
        setNewModal(false)
    }

    const openSourceModalisTrue = () => {
        setSourceModel(true)
    }

    const openSourceModalisFalse = () => {
        setSourceModel(false)
    }

    const openSourceModalisTrueEu = () => {
        setSourceModelEu(true)
    }

    const openSourceModalisFalseEu = () => {
        setSourceModelEu(false)
    }

    const openFtuPartnerModalisTrue = () => {
        setFtuPartnerModal(true)
    }

    const openFtuPartnerModalisFalse = () => {
        setFtuPartnerModal(false)
    }

    const openEuPartnerModalisTrue = () => {
        setEuPartnerModal(true)
    }

    const openEuPartnerModalisFalse = () => {
        setEuPartnerModal(false)
    }

    const openFtuResourceModalisTrue = () => {
        setFtuResourceModal(true)
    }

    const openFtuResourceModalisFalse = () => {
        setFtuResourceModal(false)
    }

    const openEuResourceModalisTrue = () => {
        setEuResourceModal(true)
    }

    const openEuResourceModalisFalse = () => {
        setEuResourceModal(false)
    }

    const openFtuProgramModalisTrue = () => {
        setFtuProgramModal(true)
    }

    const openFtuProgramModalisFalse = () => {
        setFtuProgramModal(false)
    }

    const openEuProgramModalisTrue = () => {
        setEuProgramModal(true)
    }

    const openEuProgramModalisFalse = () => {
        setEuProgramModal(false)
    }

    const goToProgramManagerDashboard = () => {
        setIsProgramManagerDashboard(!isProgramManagerDashboard)
    }

    const ondatechange = (key, date) => {
        if (key === "fromDate") {
            setfromDate(date)
        } else if (key === "toDate") {
            settoDate(date)
        }
    };

    const dateAdjusted = (date) => {
        let toDateAdjusted;
        if (date) {
            toDateAdjusted = new Date(date);

            toDateAdjusted = new Date(
                toDateAdjusted.setTime(
                    // toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
                    toDateAdjusted.getTime() + (29.5 * 60 * 60 * 1000 - 1000)
                )
            );
        }
        return toDateAdjusted;
    }

    const dateAdjusted1 = (date) => {
        let toDateAdjusted;
        if (date) {
            toDateAdjusted = new Date(date);

            toDateAdjusted = new Date(
                toDateAdjusted.setTime(
                    // toDateAdjusted.getTime() + ((6 * 60 * 60 * 1000) - (0.5 * 60 * 60 * 1000)) 
                    toDateAdjusted.getTime() + (5.5 * 60 * 60 * 1000)
                )
            );
        }
        return toDateAdjusted;
    }

    const PartnerList = ["Whatsapp", "Facebook", "WEP", "Linkedin Marketing", "desh foundation", "GMBP", "EJM", "meetups", "Youtube"]

    const ProgramList = ["New - Social Champ 1 hour Workshop", "Coach connect", "Social Champ", "Go Digital", "Social Champ Package - Digital Marketing Genius", "BLRP Orientation", "Business Loan Sarathi Package", "Free Sales Program", "Google My Business Listing for Open Market"]

    const ProgramDataStructure = [
        {
            programName: "New Program",
            partnerData: [
                {
                    resourceName: null,
                    count: 900,
                    count2: 800
                },
                {
                    resourceName: "Facebook",
                    count: 700,
                    count2: 800
                },
                {
                    resourceName: "Instagram",
                    count: 500,
                    count2: 800
                },
            ]
        },
        {
            programName: "Old Program",
            partnerData: [
                {
                    resourceName: "Whatsapp",
                    count: 100,
                    count2: 800
                },
                {
                    resourceName: "Facebook",
                    count: 200,
                    count2: 800
                },
                {
                    resourceName: null,
                    count: 400,
                    count2: 800
                },
            ]
        },
        {
            programName: "Very Old Program",
            partnerData: [
                {
                    resourceName: "Linkedin",
                    count: 100,
                    count2: 800
                },
                {
                    resourceName: "Messanger",
                    count: 200,
                    count2: 800
                },
                {
                    resourceName: "WEP",
                    count: 400,
                    count2: 800
                },
            ]
        }
    ]

    const ProgramData1 = [
        {
            sPackageTitle: "Business Loan Sarathi Package",
            partnerData: [
                {
                    sEntryPoint: "",
                    engaged_services_count: 9,
                    first_time_services_count: 1
                }
            ]
        },
        {
            sPackageTitle: "Business Loan",
            partnerData: [
                {
                    sEntryPoint: "Whatsapp",
                    engaged_services_count: 8,
                    first_time_services_count: 5
                }
            ]
        }
    ]

    const arr = []
    const [isDateSelected, setIsDateSelected] = useState(false);

    const getProgramManagerData = (ele) => {
        let filterParameters = {}

        if (fromDate) {
            filterParameters.fromDate = dateAdjusted1(fromDate)
        }

        if (toDate) {
            filterParameters.toDate = dateAdjusted(toDate)
        }

        setPartnerDataProgramManager([])
        const { tempPartnerDataForProgramManager } = api.partnerDataForProgramManager({ ...filterParameters, sProgramManager: ele.value })
            .then(({ data }) => {
                if (data.length > 0) {
                    setPartnerDataProgramManager(data)
                } else {
                    setPartnerDataProgramManager([{
                        sEntryPoint: "No Data Available",
                        FTU_Count: 0,
                        EU_Count: 0
                    }])
                }

            })

    }

    const getProgramDataforManager = (ele) => {
        let filterParameters = {}

        if (fromDate) {
            filterParameters.fromDate = dateAdjusted1(fromDate)
        }

        if (toDate) {
            filterParameters.toDate = dateAdjusted(toDate)
        }
        setProgramDataManager([])
        const { tempProgramDataForManager } = api.programDataForProgramManager({ ...filterParameters, sProgramManager: ele.value })
            .then(({ data }) => {
                if (data.length > 0) {
                    setProgramDataManager(data)
                } else {
                    setProgramDataManager([{
                        sPackageTitle: 'No Data Available',
                        FTU_Count: 0,
                        EU_Count: 0
                    }])
                }
            })
    }

    const getResourceDataForSelectedPartner = (manager, partner) => {
        let filterParameters = {}
        if (fromDate) {
            filterParameters.fromDate = dateAdjusted1(fromDate)
        }

        if (toDate) {
            filterParameters.toDate = dateAdjusted(toDate)
        }
        setResourceDataSelectedPartner([])
        const { tempResourceDataForSelectedPartner } = api.resourceDataForSelectedPartner({ ...filterParameters, sProgramManager: manager, sEntryPoint: partner })
            .then(({ data }) => {
                setResourceDataSelectedPartner(data)
            })
    }

    const getPartnerDataForSelectedProgram = (manager, program) => {
        let filterParameters = {}
        if (fromDate) {
            filterParameters.fromDate = dateAdjusted1(fromDate)
        }

        if (toDate) {
            filterParameters.toDate = dateAdjusted(toDate)
        }
        setPartnerDataForSelectedProgram([])
        const { tempPartnerDataForSelectedProgram } = api.partnerDataForSelectedPro({ ...filterParameters, sProgramManager: manager, sPackageTitle: program })
            .then(({ data }) => {
                setPartnerDataForSelectedProgram(data)
            })
    }

    const getTableData = () => {
        let filterParameters = {}

        if (fromDate) {
            filterParameters.fromDate = dateAdjusted1(fromDate)
        }

        if (toDate) {
            filterParameters.toDate = dateAdjusted(toDate)
        }

        if(fromDate && toDate){
            setIsDateSelected(true)
        } else {
            setIsDateSelected(false)
        }


        console.log(filterParameters, "FilterData");

        const { tempPartner } = api.getFirstTimeUserPartnerData().then(({ data }) => {
            if (data) {
                setPartnerListData(data)
            }
        })

        const { tempProgram } = api.getFirstTimeProgramData({
            fromDate: dateAdjusted1(fromDate),
            toDate: dateAdjusted(toDate)
        }).then(({ data }) => {
            if (data) {
                // console.log("tempProgram",data)
                setFirstTimeProgramName(data)
            }
        })
        const { tempProgram1 } = api.getEngagedUserProgramData({
            fromDate: dateAdjusted1(fromDate),
            toDate: dateAdjusted(toDate)
        }).then(({ data }) => {
            if (data) {
                console.log("tempProg",data)
                setEngagedProgramName(data)
            }
        })

        const {tempsourceftu} = api.getFirstTimeSourceMediumData().then(({data}) => {
            if(data){
                const sourceNames = data.reduce((uniqueNames, row) => {
                    if (row.sourse_name && (row.sourse_name != null && row.sourse_name != "") && !uniqueNames.includes(row.sourse_name)) {
                      uniqueNames.push(row.sourse_name);
                    }
                    return uniqueNames;
                  }, []);
                  setSourceListData(sourceNames)

                  const mediumNames = data.reduce((uniqueNames, row) => {
                    if (row.medium_name && (row.medium_name != null && row.medium_name != "") && !uniqueNames.includes(row.medium_name)) {
                      uniqueNames.push(row.medium_name);
                    }
                    return uniqueNames;
                  }, []);
                  setMediumListData(mediumNames)
            }
        })

        const {tempsourceEu} = api.getEngagedSourceMediumData().then(({data}) => {
            if(data){
                const sourceNames = data.reduce((uniqueNames, row) => {
                    if (row.sourse_name && (row.sourse_name != null && row.sourse_name != "") && !uniqueNames.includes(row.sourse_name)) {
                      uniqueNames.push(row.sourse_name);
                    }
                    return uniqueNames;
                  }, []);
                  setSourceListDataEu(sourceNames)

                  const mediumNames = data.reduce((uniqueNames, row) => {
                    if (row.medium_name && (row.medium_name != null && row.medium_name != "") && !uniqueNames.includes(row.medium_name)) {
                      uniqueNames.push(row.medium_name);
                    }
                    return uniqueNames;
                  }, []);
                  setMediumListDataEu(mediumNames)
            }
        })

        if (programListUpdated.length != 0 && partnerListUpdated.length != 0) {
            const { tempServices15 } = api.getFilterPartnerData({ ...filterParameters, partner: partnerListUpdated })
                .then(({ data }) => {
                    if (data) {
                        setPartnerTableData(data)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })

            const { tempServices16 } = api.getFilterProgramData({ ...filterParameters, program: programListUpdated })
                .then(({ data }) => {
                    if (data) {
                        setProgramTableData(data)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })
        } else if (programListUpdated.length != 0) {
            const { tempServices16 } = api.getFilterProgramData({ ...filterParameters, program: programListUpdated })
                .then(({ data }) => {
                    if (data) {
                        if(data.length > 0){
                            setProgramTableData(data)
                        } else {
                            setProgramTableData([''])
                        }
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })
        } else if (partnerListUpdated.length != 0) {
            const { tempServices15 } = api.getFilterPartnerData({ ...filterParameters, partner: partnerListUpdated })
                .then(({ data }) => {
                    if (data) {
                        if(data.length > 0){
                            setPartnerTableData(data)
                        }else {
                            setPartnerTableData(arr)
                        }
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })
        } else {
            //Table Data API

            const { tempService } = api.getResourceCount(filterParameters).then(({ data }) => {
                if (data) {
                    setResourceCount(data[0]);
                }
                else {
                    toast("", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
            }).catch((error) => {
                if (error.response.data.detail !== "Authentication credentials were not provided.") {
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else if (error.response.data.message) {
                    toast(String(error.response.data.message), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }

            });

            const { tempServices } = api.getengagedusercount(filterParameters).then(({ data }) => {
                if (data) {
                    setCountData(data[0]);
                }
                else {
                    toast("", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
            }).catch((error) => {
                if (error.response.data.detail !== "Authentication credentials were not provided.") {
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else if (error.response.data.message) {
                    toast(String(error.response.data.message), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }

            });

            const { tempServices1 } = api.getFirstTimeusersDashboradData(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        setFtuGridData(data)
                        setRawFtuResourceData(data)
                        const sourceNames = data.reduce((uniqueNames, row) => {
                    if (row.resourse_name && (row.resourse_name != null && row.resourse_name != "") && !uniqueNames.includes(row.resourse_name)) {
                      uniqueNames.push(row.resourse_name);
                    }
                    return uniqueNames;
                  }, []);
                  setFtuResourceListData(sourceNames)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })

            const { tempServices2 } = api.getEngagedusersDashboradData(filterParameters)
                .then(({ data }) => {
                    if (data) {
                            setEuGridData(data)
                        setRawEuResourceData(data)
                        const sourceNames = data.reduce((uniqueNames, row) => {
                    if (row.resourse_name && (row.resourse_name != null && row.resourse_name != "") && !uniqueNames.includes(row.resourse_name)) {
                      uniqueNames.push(row.resourse_name);
                    }
                    return uniqueNames;
                  }, []);
                  setEuResourceListData(sourceNames)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })

            const { tempServices3 } = api.getFirstTimeUserPartnerData({ ...filterParameters })
                .then(({ data }) => {
                    if (data) {
                        setFirstTimePartnerData(data)
                        setRawFtuPartnerData(data)
                        const sourceNames = data.reduce((uniqueNames, row) => {
                            if (row.resource_name && (row.resource_name != null && row.resource_name != "") && !uniqueNames.includes(row.resource_name)) {
                              uniqueNames.push(row.resource_name);
                            }
                            return uniqueNames;
                          }, []);
                          setFtuPartnerListData(sourceNames)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })


            const { tempServices4 } = api.getEngagedUserPartnerData({ ...filterParameters, program: programListUpdated })
                .then(({ data }) => {
                    if (data) {
                        setEngagedPartner(data)
                        setRawEuPartnerData(data)
                        const sourceNames = data.reduce((uniqueNames, row) => {
                            if (row.resource_name && (row.resource_name != null && row.resource_name != "") && !uniqueNames.includes(row.resource_name)) {
                              uniqueNames.push(row.resource_name);
                            }
                            return uniqueNames;
                          }, []);
                          setEuPartnerListData(sourceNames)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })
            //   }



            const { tempServices5 } = api.getFirstTimeAnnualTurnover(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        setFirstTimeAnnualTurnoverData(data)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })

            const { tempServices6 } = api.getEngagedAnnualTurnover(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        setEngagedAnnualTurnoverData(data)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })

            const { tempServices7 } = api.getFirstTimeSourceMediumData(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        setFtuSourceAndMediumData(data)
                        setRawSourceMediumData(data)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })

            const { tempServices8 } = api.getEngagedSourceMediumData(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        setEngagedSourceAndMediumData(data)
                        setRawSourceMediumDataEu(data)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })

            const { tempServices9 } = api.getMonthWiseData(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        setMonthwiseData(data)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })

            //Chart Data API

            // const { tempServices10 } = api.getFirstTimeUserChartData(filterParameters)
            //     .then(({ data }) => {
            //         if (data) {
            //             setFirstTimeChartData(data)
            //         } else {
            //             toast("", {
            //                 autoClose: 5000,
            //                 type: toast.TYPE.ERROR,
            //             })
            //         }
            //     }).catch((error) => {
            //         if (error.response.data.detail !== "Authentication credentials were not provided.") {
            //             toast(String(error.response.data.detail), {
            //                 autoClose: 5000,
            //                 type: toast.TYPE.ERROR,
            //             });
            //         } else if (error.response.data.message) {
            //             toast(String(error.response.data.message), {
            //                 autoClose: 5000,
            //                 type: toast.TYPE.ERROR,
            //             });
            //         }
            //     })

            // const { tempServices11 } = api.getEngagedUserChartData(filterParameters)
            //     .then(({ data }) => {
            //         if (data) {
            //             setEngagedChartData(data)
            //         } else {
            //             toast("", {
            //                 autoClose: 5000,
            //                 type: toast.TYPE.ERROR,
            //             })
            //         }
            //     }).catch((error) => {
            //         if (error.response.data.detail !== "Authentication credentials were not provided.") {
            //             toast(String(error.response.data.detail), {
            //                 autoClose: 5000,
            //                 type: toast.TYPE.ERROR,
            //             });
            //         } else if (error.response.data.message) {
            //             toast(String(error.response.data.message), {
            //                 autoClose: 5000,
            //                 type: toast.TYPE.ERROR,
            //             });
            //         }
            //     })

            // const { tempServices12 } = api.getResourceAwailedChartData(filterParameters)
            //     .then(({ data }) => {
            //         if (data) {
            //             setResourceAwailedChartData(data)
            //         } else {
            //             toast("", {
            //                 autoClose: 5000,
            //                 type: toast.TYPE.ERROR,
            //             })
            //         }
            //     }).catch((error) => {
            //         if (error.response.data.detail !== "Authentication credentials were not provided.") {
            //             toast(String(error.response.data.detail), {
            //                 autoClose: 5000,
            //                 type: toast.TYPE.ERROR,
            //             });
            //         } else if (error.response.data.message) {
            //             toast(String(error.response.data.message), {
            //                 autoClose: 5000,
            //                 type: toast.TYPE.ERROR,
            //             });
            //         }
            //     })

            const { tempServices13 } = api.getFirstTimeProgramData(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        setFirstTimeProgramData(data)
                        setProgramListData(data)
                        setRawFtuProgramData(data)
                        const sourceNames = data.reduce((uniqueNames, row) => {
                            if (row.resource_name && (row.resource_name != null && row.resource_name != "") && !uniqueNames.includes(row.resource_name)) {
                              uniqueNames.push(row.resource_name);
                            }
                            return uniqueNames;
                          }, []);
                          setFtuProgramListData(sourceNames)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })

            const { tempServices14 } = api.getEngagedUserProgramData(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        setEngagedUserProgramData(data)
                        setRawEuProgramData(data)
                        const sourceNames = data.reduce((uniqueNames, row) => {
                            if (row.resource_name && (row.resource_name != null && row.resource_name != "") && !uniqueNames.includes(row.resource_name)) {
                              uniqueNames.push(row.resource_name);
                            }
                            return uniqueNames;
                          }, []);
                          setEuProgramListData(sourceNames)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })

                const { tempFirstTimePartnerResource } = api.getFirstTimePartnerResourceData(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        setFirstTimePartnerResourceData(data)
                        // setRawEuProgramData(data)
                        // const sourceNames = data.reduce((uniqueNames, row) => {
                        //     if (row.resourse_name && (row.resourse_name != null && row.resourse_name != "") && !uniqueNames.includes(row.resourse_name)) {
                        //       uniqueNames.push(row.resourse_name);
                        //     }
                        //     return uniqueNames;
                        //   }, []);
                        //   setEuProgramListData(sourceNames)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })

                const { tempEngagedPartnerResource } = api.getEngagedPartnerResourceData(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        setEngagedPartnerResourceData(data)
                        // setRawEuProgramData(data)
                        // const sourceNames = data.reduce((uniqueNames, row) => {
                        //     if (row.resourse_name && (row.resourse_name != null && row.resourse_name != "") && !uniqueNames.includes(row.resourse_name)) {
                        //       uniqueNames.push(row.resourse_name);
                        //     }
                        //     return uniqueNames;
                        //   }, []);
                        //   setEuProgramListData(sourceNames)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })


                const { tempFirstTimeProgramResource } = api.getFirstTimeProgramResourceData(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        setFirstTimeProgramResourceData(data)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })

                const { tempEngagedProgramResource } = api.getEngagedProgramResourceData(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        setEngagedProgramResourceData(data)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })
        }
    }

    const EngagedPartnerResourceData = [{
        "entrypoint_name": "3KM",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "3KM",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 2
    },
    {
        "entrypoint_name": "3KM",
        "resourcedisplay_name": "Group Expert Consult",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "ABBM_Nagpur",
        "resourcedisplay_name": "Business Performance Evaluation Tool",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "ABBM_Nagpur",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 3
    },
    {
        "entrypoint_name": "ABBM_Nagpur",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 29
    },
    {
        "entrypoint_name": "ABBM_Nagpur",
        "resourcedisplay_name": "dePreneur Listing",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "ABBM_Nagpur",
        "resourcedisplay_name": "Group Expert Consult",
        "resourse_count": 18
    },
    {
        "entrypoint_name": "ABBM_Nagpur",
        "resourcedisplay_name": "Group Experts Consultation",
        "resourse_count": 4
    },
    {
        "entrypoint_name": "Amazon_Saheli",
        "resourcedisplay_name": "deAsra Business Listing",
        "resourse_count": 6
    },
    {
        "entrypoint_name": "Amazon_Saheli",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 5
    },
    {
        "entrypoint_name": "Amhi_Udyogini",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 10
    },
    {
        "entrypoint_name": "Amhi_Udyogini",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 83
    },
    {
        "entrypoint_name": "Amhi_Udyogini",
        "resourcedisplay_name": "Funding Readiness Assessment Tool",
        "resourse_count": 2
    },
    {
        "entrypoint_name": "Amhi_Udyogini",
        "resourcedisplay_name": "Group Expert Consult",
        "resourse_count": 74
    },
    {
        "entrypoint_name": "Ankur_Incubation",
        "resourcedisplay_name": "Blog View",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Ankur_Incubation",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 7
    },
    {
        "entrypoint_name": "Ankur_Incubation",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 20
    },
    {
        "entrypoint_name": "Ankur_Incubation",
        "resourcedisplay_name": "Group Expert Consult",
        "resourse_count": 16
    },
    {
        "entrypoint_name": "Ankur_Incubation",
        "resourcedisplay_name": "Social Media Marketing Checklist",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Ashwamedh Expo",
        "resourcedisplay_name": "deAsra Business Listing",
        "resourse_count": 17
    },
    {
        "entrypoint_name": "Ashwamedh Expo",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 4
    },
    {
        "entrypoint_name": "Ashwamedh Expo",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 4
    },
    {
        "entrypoint_name": "Ashwamedh Expo",
        "resourcedisplay_name": "Group Expert Consult",
        "resourse_count": 3
    },
    {
        "entrypoint_name": "Ashwamedh_expo",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "AspireForHer",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "AspireForHer",
        "resourcedisplay_name": "Group Expert Consult",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Atharva_AccFin",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 2
    },
    {
        "entrypoint_name": "Atharva_AccFin",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 16
    },
    {
        "entrypoint_name": "Atharva_AccFin",
        "resourcedisplay_name": "Group Expert Consult",
        "resourse_count": 16
    },
    {
        "entrypoint_name": "Atharva_Finance",
        "resourcedisplay_name": "Trademark Application Filing",
        "resourse_count": 1
    }]



    
    const FirstTimePartnerResourceData = [{
        "entrypoint_name": "3KM",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 11
    },
    {
        "entrypoint_name": "3KM",
        "resourcedisplay_name": "Sign Up",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "ABBM_Nagpur",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 24
    },
    {
        "entrypoint_name": "ABBM_Nagpur",
        "resourcedisplay_name": "Group Experts Consultation",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "ABBM_Nagpur",
        "resourcedisplay_name": "Sign Up",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Amazon_Saheli",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 3
    },
    {
        "entrypoint_name": "Amhi_Udyogini",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 88
    },
    {
        "entrypoint_name": "Amhi_Udyogini",
        "resourcedisplay_name": "Funding Readiness Assessment Tool",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Amhi_Udyogini",
        "resourcedisplay_name": "Sign Up",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Ankur_Incubation",
        "resourcedisplay_name": "Compare Options & Apply for MSME Business Loan",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Ankur_Incubation",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 14
    },
    {
        "entrypoint_name": "Ankur_Incubation",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Ankur_Incubation",
        "resourcedisplay_name": "FSSAI Registration",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Apple_salon",
        "resourcedisplay_name": "Funding proposal creation",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "AspireForHer",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Atharva_AccFin",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 15
    },
    {
        "entrypoint_name": "Atharva_Finance",
        "resourcedisplay_name": "Udyam Registration Checklist",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Baramati_Business_Group",
        "resourcedisplay_name": "Group Experts Consultation",
        "resourse_count": 43
    },
    {
        "entrypoint_name": "Baramati_Incubation",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Baramati_Incubation",
        "resourcedisplay_name": "Group Experts Consultation",
        "resourse_count": 13
    },
    {
        "entrypoint_name": "BBN",
        "resourcedisplay_name": "Group Experts Consultation",
        "resourse_count": 103
    },
    {
        "entrypoint_name": "BBNG",
        "resourcedisplay_name": "Events Registration",
        "resourse_count": 2
    },
    {
        "entrypoint_name": "BBNG",
        "resourcedisplay_name": "FSSAI License",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "BBN_Sangli",
        "resourcedisplay_name": "Group Experts Consultation",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Bhadipa",
        "resourcedisplay_name": "Compare options & Apply for MSME Business Loan",
        "resourse_count": 19
    },
    {
        "entrypoint_name": "Bhadipa",
        "resourcedisplay_name": "Sign Up",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "BITO",
        "resourcedisplay_name": "deAsra Business Listing",
        "resourse_count": 26
    },
    {
        "entrypoint_name": "BITO",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 9
    },
    {
        "entrypoint_name": "BITO",
        "resourcedisplay_name": "dePreneur Listing",
        "resourse_count": 8
    },
    {
        "entrypoint_name": "BITO",
        "resourcedisplay_name": "Sign Up",
        "resourse_count": 1
    }]


    const firstTimeProgramResourceData1 = [  {
        "packagetitle_name": "Taxation for MSME's",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 4
    },
    {
        "packagetitle_name": "Townsquare for J4E",
        "resourcedisplay_name": "Townsquare Service",
        "resourse_count": 10
    },
    {
        "packagetitle_name": "Understanding & Application of Finance in Business",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 9
    },
    {
        "packagetitle_name": "Understanding & Application of Finance in Business 26 May",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 33
    },
    {
        "packagetitle_name": "Understanding Government Schemes/Initiatives For MSMEs",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 144
    },
    {
        "packagetitle_name": "Understanding Govt. Schemes and Initiatives for MSME's",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 98
    },
    {
        "packagetitle_name": "Vrindavan_Banquet (3rd March 2023)",
        "resourcedisplay_name": "Group Experts Consultation",
        "resourse_count": 15
    },
    {
        "packagetitle_name": "WhatsApp for Business - 3rd June 2022",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 48
    },
    {
        "packagetitle_name": "WhatsApp for Business Training - Oct. 2022",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 19
    },
    {
        "packagetitle_name": "Xpert Consultation",
        "resourcedisplay_name": "deAsra Experts",
        "resourse_count": 8
    },
    {
        "packagetitle_name": "Xpert Consultation Package",
        "resourcedisplay_name": "deAsra Experts",
        "resourse_count": 4
    },
    {
        "packagetitle_name": "Xpert Consultation Package",
        "resourcedisplay_name": "Xpert Cliniq",
        "resourse_count": 26
    },
    {
        "packagetitle_name": "– All about Udyam Registration for your Business",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 3
    }
] 

const engagedProgramResourceData1 = [ {
    "packagetitle_name": "Xpert Consultation",
    "resourcedisplay_name": "deAsra Experts",
    "resourse_count": 2
},
{
    "packagetitle_name": "Xpert Consultation",
    "resourcedisplay_name": "Expert Consult",
    "resourse_count": 10
},
{
    "packagetitle_name": "Xpert Consultation",
    "resourcedisplay_name": "Expert Consultation",
    "resourse_count": 14
},
{
    "packagetitle_name": "Xpert Consultation Package",
    "resourcedisplay_name": "Expert Consult",
    "resourse_count": 2
},
{
    "packagetitle_name": "Xpert Consultation Package",
    "resourcedisplay_name": "Expert Consultation",
    "resourse_count": 6
},
{
    "packagetitle_name": "Xpert Consultation Package",
    "resourcedisplay_name": "Xpert Cliniq",
    "resourse_count": 44
},
{
    "packagetitle_name": "– All about Udyam Registration for your Business",
    "resourcedisplay_name": "DeAsra Marketing Event",
    "resourse_count": 37
},
{
    "packagetitle_name": "– All about Udyam Registration for your Business",
    "resourcedisplay_name": "deAsra Program",
    "resourse_count": 39
},
{
    "packagetitle_name": "– All about Udyam Registration for your Business",
    "resourcedisplay_name": "Group Expert Consult",
    "resourse_count": 39
}
]

    const handleFilterClick = () => {
        openFilterModalisTrue()
    }

    const handleSourceModelClick = () => {
        openSourceModalisTrue()
    }

    const handleSourceModelClickEu = () => {
        openSourceModalisTrueEu()
    }

    const handleFtuPartnerModalClick = () => {
        openFtuPartnerModalisTrue()
    }

    const handleEuPartnerModalClick = () => {
        openEuPartnerModalisTrue()
    }

    const handleFtuResourceModalClick = () => {
        openFtuResourceModalisTrue()
    }

    const handleEuResourceModalClick = () => {
        openEuResourceModalisTrue()
    }

    const handleFtuProgramModalClick = () => {
        openFtuProgramModalisTrue()
    }

    const handleEuProgramModalClick = () => {
        openEuProgramModalisTrue()
    }

    const partnerList1 = []
    const programList1 = []

    partnerListdata.map((ele) => {
        if (ele.resource_name != null && ele.resource_name != "") {
            partnerList1.push(ele.resource_name)
        }
    })

    programListdata.map((ele) => {
        if (ele.resource_name != null && ele.resource_name != "") {
            programList1.push(ele.resource_name)
        }
    })

    const mergedResourceNames = [];

    // Extract resource names from the first data array
    const resourceNames1 = firstTimeProgramName.map((item) => item.resource_name).filter((name) => name !== "" && name !== null);

    // Extract resource names from the second data array
    const resourceNames2 = engagedProgramName.map((item) => item.resource_name).filter((name) => name !== "" && name !== null);


    // Merge the resource names and remove duplicates
    const mergedResourceNamesSet = new Set([...resourceNames1, ...resourceNames2]);
    mergedResourceNames.push(...mergedResourceNamesSet);

    console.log("M++",mergedResourceNames);

    const handleSourceFilterSearchClick = () => {
        const filteredData = rawSourceMediumData.filter(obj => selectedOptionsSource.some(item => item.value === obj.sourse_name));
        const filteredData1 = rawSourceMediumData.filter(obj => selectedOptionsMedium.some(item => item.value === obj.medium_name));
        const filteredData2 = rawSourceMediumData.filter(obj =>
            selectedOptionsSource.some(item => item.value === obj.sourse_name) &&
            selectedOptionsMedium.some(item => item.value === obj.medium_name)
        );

        if (selectedOptionsSource.length > 0 && selectedOptionsMedium.length > 0) {
            if(filteredData2.length > 0){
                setFtuSourceAndMediumData(filteredData2)
            } else{
                setFtuSourceAndMediumData([{
                    sourse_name: "No Data Available",
                    medium_name: " ",
                    resourse_count: ""
                }])
            }
            openSourceModalisFalse()
        } else if (selectedOptionsSource.length > 0) {
            setFtuSourceAndMediumData(filteredData)
            console.log("test", ftuSourceAndMediumData)
            openSourceModalisFalse()
        } else if (selectedOptionsMedium.length > 0) {
            setFtuSourceAndMediumData(filteredData1)
            console.log("test1", ftuSourceAndMediumData)
            openSourceModalisFalse()
        } else {
            setFtuSourceAndMediumData(rawSourceMediumData)
            openSourceModalisFalse()
        }
    }

    const handleSourceFilterSearchClickEu= () => {
        const filteredData = rawSourceMediumDataEu.filter(obj => selectedOptionsSourceEu.some(item => item.value === obj.sourse_name));
        const filteredData1 = rawSourceMediumDataEu.filter(obj => selectedOptionsMediumEu.some(item => item.value === obj.medium_name));
        const filteredData2 = rawSourceMediumDataEu.filter(obj =>
            selectedOptionsSourceEu.some(item => item.value === obj.sourse_name) &&
            selectedOptionsMediumEu.some(item => item.value === obj.medium_name)
        );

        if (selectedOptionsSourceEu.length > 0 && selectedOptionsMediumEu.length > 0) {
            if(filteredData2.length > 0){
                setEngagedSourceAndMediumData(filteredData2)
            } else{
                setEngagedSourceAndMediumData([{
                    sourse_name: "No Data Available",
                    medium_name: " ",
                    resourse_count: ""
                }])
            }
            openSourceModalisFalseEu()
        } else if (selectedOptionsSourceEu.length > 0) {
            setEngagedSourceAndMediumData(filteredData)
            openSourceModalisFalseEu()
        } else if (selectedOptionsMediumEu.length > 0) {
            setEngagedSourceAndMediumData(filteredData1)
            openSourceModalisFalseEu()
        } else {
            setEngagedSourceAndMediumData(rawSourceMediumDataEu)
            openSourceModalisFalseEu()
        }
    }

    const handleFtuFilterSearchClick = () => {
        const filteredData = rawFtuPartnerData.filter(obj => selectedOptionsFtuPartner.some(item => item.value === obj.resource_name));
        if(selectedOptionsFtuPartner.length > 0){
            if(filteredData.length > 0){
                setFirstTimePartnerData(filteredData)
            } else {
                setFirstTimePartnerData([{
                    resource_name: "No Data Available",
                    resource_count: ''
                }])
            }
            openFtuPartnerModalisFalse()                   
        } else {
                setFirstTimePartnerData(rawFtuPartnerData)
                openFtuPartnerModalisFalse()
        }
    }

    const handleEuFilterSearchClick = () => {
        const filteredData = rawEuPartnerData.filter(obj => selectedOptionsEuPartner.some(item => item.value === obj.resource_name));
        if(selectedOptionsEuPartner.length > 0){
            if(filteredData.length > 0){
                setEngagedPartner(filteredData)
                
            } else {
                setEngagedPartner([{
                    resource_name: "No Data Available",
                    resource_count: ''
                }])
            }   
            openEuPartnerModalisFalse()        
        } else {
                setEngagedPartner(rawEuPartnerData)
                openEuPartnerModalisFalse()
        }
    }

    const handleFtuResourceFilterSearchClick = () => {
        const filteredData = rawFtuResourceData.filter(obj => selectedOptionsFtuResource.some(item => item.value === obj.resourse_name));
        if(selectedOptionsFtuResource.length > 0){
            if(filteredData.length > 0){
                setFtuGridData(filteredData)
            } else {
                setFtuGridData([{
                    resourse_name: "No Data Available",
                    resourse_count: ''
                }])
            }
                openFtuResourceModalisFalse()            
        } else {
                setFtuGridData(rawFtuResourceData)
                openFtuResourceModalisFalse()
        }
    }

    const handleEuResourceFilterSearchClick = () => {
        const filteredData = rawEuResourceData.filter(obj => selectedOptionsEuResource.some(item => item.value === obj.resourse_name));
        if(selectedOptionsEuResource.length > 0){
            if(filteredData.length > 0){
                setEuGridData(filteredData)
            } else {
                setEuGridData([{
                    resourse_name: "No Data Available",
                    resourse_count: ''
                }])
            }
                openEuResourceModalisFalse()            
        } else {
                setEuGridData(rawEuResourceData)
                openEuResourceModalisFalse()
        }
    }

    const handleFtuProgramFilterSearchClick = () => {
        const filteredData = rawFtuProgramData.filter(obj => selectedOptionsFtuProgram.some(item => item.value === obj.resource_name));
        if(selectedOptionsFtuProgram.length > 0){
            if(filteredData.length > 0) {
                setFirstTimeProgramData(filteredData)
            }else {
                setFirstTimeProgramData([{
                    resource_name: "No Data Available",
                    resource_count: ''
                }])
            }
                openFtuProgramModalisFalse()            
        } else {
                setFirstTimeProgramData(rawFtuProgramData)
                openFtuProgramModalisFalse()
        }
        console.log("Filtered Data", firstTimeProgramData)
    }

    const handleEuProgramFilterSearchClick = () => {
        const filteredData = rawEuProgramData.filter(obj => selectedOptionsEuProgram.some(item => item.value === obj.resource_name));
        if(selectedOptionsEuProgram.length > 0){
            if(filteredData.length > 0){
                setEngagedUserProgramData(filteredData)
            } else{
                setEngagedUserProgramData([{
                    resource_name: "No Data Available",
                    resource_count: ''
                }])
            }
                openEuProgramModalisFalse()            
        } else {
                setEngagedUserProgramData(rawEuProgramData)
                openEuProgramModalisFalse()
        }
    }

    const [isClearClicked, setIsClearClicked] = useState(false);

    const handleClearClick = () => {
        if (!isProgramManagerDashboard) {
            setSelectedOptions([])
            setFtuGridData([])
            setEuGridData([])
            setFirstTimePartnerData([])
            setEngagedPartner([])
            setFirstTimeAnnualTurnoverData([])
            setEngagedAnnualTurnoverData([])
            setFtuSourceAndMediumData([])
            setEngagedSourceAndMediumData([])
            setFirstTimeChartData([])
            setEngagedChartData([])
            setResourceAwailedChartData([])
            setFirstTimeProgramData([])
            setEngagedUserProgramData([])
            setPartnerTableData([])
            setProgramTableData([])
            setFirstTimePartnerResourceData([])
            setEngagedPartnerResourceData([])
            setFirstTimeProgramResourceData([])
            setEngagedProgramResourceData([])
            setSelectedOptionsProgram([])
            setfromDate()
            settoDate()
            setSelectedOptionsSource([])
            setSelectedOptionsMedium([])
            setSelectedOptionsSourceEu([])
            setSelectedOptionsMediumEu([])
            setSelectedOptionsEuPartner([])
            setSelectedOptionsFtuPartner([])
            setSelectedOptionsEuResource([])
            setSelectedOptionsFtuResource([])
            setSelectedOptionsEuProgram([])
            setSelectedOptionsFtuProgram([])
            setSelectedOptionsMergedPartner([])
            setSelectedOptionsMergedProgram([])
            setSelectedOptionsMergedResource([])
            setSelectedOptionsMergedPartnerResource([])
            setSelectedOptionsMergedPartnerResourceEu([])
            setSelectedOptionsMergedProgramResource([])
            setSelectedOptionsMergedProgramResourceEu([])
            setSelectedOptionsMergedSourceMedium([])
            setSelectedOptionsMergedSourceMediumEu([])
            setIsProgramData(false);
            setIsClearClicked(true);
            localStorage.removeItem("fromDate")
            localStorage.removeItem("toDate")
        } else {
            setfromDate()
            settoDate()
            setSelectedProgramManager([])
            setPartnerDataProgramManager([])
            setProgramDataManager([])
            localStorage.removeItem("fromDate")
            localStorage.removeItem("toDate")
        }
    }   

    useEffect(() => {
        if (isClearClicked) {
          getTableData(); // Call getTableData when isClearClicked is true
          setIsClearClicked(false); // Reset the clear flag to false
        }
      }, [isClearClicked]);

      useEffect(() => {
        const handleBeforeUnload = () => {
          localStorage.removeItem('fromDate');
          localStorage.removeItem('toDate')
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
    
        return () => {
          window.removeEventListener('beforeunload', handleBeforeUnload);
        };
      }, []);


    const handleFilterByModalClearClick = () => {
        setSelectedOptions([])
        setSelectedOptionsProgram([])
        setfromDate()
        settoDate()
    }
    
    const handleEuSourceFilterClearClick = () => {
        setSelectedOptionsSourceEu([])
        setSelectedOptionsMediumEu([])
    } 

    const handleFtuSourceFilterClearClick = () => {
        setSelectedOptionsSource([])
        setSelectedOptionsMedium([])
    } 

    const handleEuPartnerFilterClearClick = () => {
        setSelectedOptionsEuPartner([])
    } 

    const handleFtuPartnerFilterClearClick = () => {
        setSelectedOptionsFtuPartner([])
    }

    const handleEuResourceFilterClearClick = () => {
        setSelectedOptionsEuResource([])
    } 

    const handleFtuResourceFilterClearClick = () => {
        setSelectedOptionsFtuResource([])
    }

    const handleEuProgramFilterClearClick = () => {
        setSelectedOptionsEuProgram([])
    } 

    const handleFtuProgramFilterClearClick = () => {
        setSelectedOptionsFtuProgram([])
    }

    const handleSearchClick = async () => {
        if (!fromDate && !toDate) {
            localStorage.removeItem("fromDate")
            localStorage.removeItem("toDate")
        }
        fromDate && localStorage.setItem("fromDate", fromDate.toLocaleDateString("en-GB"))
        toDate && localStorage.setItem("toDate", toDate.toLocaleDateString("en-GB"))

        if (!isProgramManagerDashboard) {
            selectedOptions.map((ele) => {
                partnerListUpdated.push(ele.value)
            })
            partnerListUpdated.map((ele) => {
                arr.push(
                    {
                        resource_name: ele,
                        First_Time_Usres: 0,
                        Engaged_Users: 0
                    }
                )
            })

            console.log("Np", arr)

            selectedOptionsProgram.map((element) => {
                programListUpdated.push(element.value)
            })

            // const filteredData = rawSourceMediumData.filter(obj => selectedOptionsSource.some(item => item.value === obj.sourse_name));
            // const filteredData1 = rawSourceMediumData.filter(obj => selectedOptionsMedium.some(item => item.value === obj.medium_name));
            // const filteredData2 = rawSourceMediumData.filter(obj => 
            //     selectedOptionsSource.some(item => item.value === obj.sourse_name) && 
            //     selectedOptionsMedium.some(item => item.value === obj.medium_name)
            //   );
            setIsPartnerData(selectedOptions.length !== 0, () => {
                console.log('isPartnerData:', isPartnerData);
            });
            setIsProgramData(selectedOptionsProgram.length !== 0, () => {
                console.log('isProgramData:', isProgramData);
            });
            // if(selectedOptionsSource.length > 0 && !selectedOptionsMedium){
            //     setFtuSourceAndMediumData(filteredData) 
            //     console.log("test",ftuSourceAndMediumData)
            //     openFilterModalisFalse()
            // } else if(selectedOptionsMedium.length > 0 && !selectedOptionsSource){
            //     setFtuSourceAndMediumData(filteredData1) 
            //     console.log("test1",ftuSourceAndMediumData)
            //     openFilterModalisFalse()
            // } else if(selectedOptionsSource.length > 0 && selectedOptionsMedium.length > 0){
            //     setFtuSourceAndMediumData(filteredData2)
            //     openFilterModalisFalse()
            // }
            // if(selectedOptionsSource.length > 0 && selectedOptionsMedium.length > 0){
            //         setFtuSourceAndMediumData(filteredData2)
            //         openFilterModalisFalse()
            //     }else if(selectedOptionsSource.length > 0){
            //             setFtuSourceAndMediumData(filteredData) 
            //             console.log("test",ftuSourceAndMediumData)
            //             openFilterModalisFalse()
            //         } else if(selectedOptionsMedium.length > 0){
            //             setFtuSourceAndMediumData(filteredData1) 
            //             console.log("test1",ftuSourceAndMediumData)
            //             openFilterModalisFalse()
            //         } else{

            openFilterModalisFalse()
            setFtuGridData([])
            setEuGridData([])
            setFirstTimePartnerData([])
            setEngagedPartner([])
            setFirstTimeAnnualTurnoverData([])
            setEngagedAnnualTurnoverData([])
            setFtuSourceAndMediumData([])
            setEngagedSourceAndMediumData([])
            setFirstTimeChartData([])
            setEngagedChartData([])
            setResourceAwailedChartData([])
            setFirstTimeProgramData([])
            setEngagedUserProgramData([])
            setPartnerTableData([])
            setProgramTableData([])
            setFirstTimePartnerResourceData([])
            setEngagedPartnerResourceData([])
            setFirstTimeProgramResourceData([])
            setEngagedProgramResourceData([])
            getTableData()
        } else {
            openFilterModalisFalse()
            if (selectedProgramManager) {
                getProgramManagerData(selectedProgramManager)
                getProgramDataforManager(selectedProgramManager)
            }
        }

        // }
    }

    useEffect(() => {
        getTableData()
    }, [])    

    return (
        <div>
            {/* <div className="row mt-3 mb-4"> */}
            <div className={`${!isPartnerData && !isProgramData ? "row mt-3 mb-4" : "row mt-2"}`}>
                <div className="col-2">
                    {
                        !isPartnerData && !isProgramData ?
                        <div style={{
                            backgroundColor: '#78417C',
                            color: "#fff"
                        }} className="esp-dashboard-card conv-text-center"
                        title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                        >
                            <label className="esp-box-header-title">All time FTU</label>
                            <h5 className="esp-count-text1">{TotalFirstTimeUserCount || 0}</h5>
                            <div style={{ clear: "both" }}></div>
                        </div>

                            :
                            ""
                    }

                </div>

                <div className="col-2">
                    {
                        !isPartnerData && !isProgramData ?
                        <div style={{
                            backgroundColor: '#78417C',
                            color: "#fff"
                        }} className="esp-dashboard-card conv-text-center"
                        title='Displays the Count of Engaged Users where mobile number is mandatory + all the count before that.'
                        >
                            <label className="esp-box-header-title">All time EU</label>
                            <h5  className="esp-count-text1" style={{
                                color: "#fff !important"
                            }}>{TotalEngagedUserCount || 0}</h5>
                            <div style={{ clear: "both" }}></div>
                        </div>

                            :
                            ""
                    }
                </div>

                <div className="col-2">
                    {
                        !isPartnerData && !isProgramData ?
                        <div style={{
                            backgroundColor: '#78417C',
                            color: "#fff"
                        }} className="esp-dashboard-card conv-text-center" 
                        title='Displays the Count of All time Data of Resources Availed by users'>
                            <label className="esp-box-header-title">All Time Resources Availed</label>
                            <h5 className="esp-count-text1" style={{
                                color: "#fff !important"
                            }}>{TotalResourceAvailedCount || 0}</h5>
                                <div style={{ clear: "both" }}></div>
                            </div>
                            :
                            ""
                    }
                </div>

                <div className="col-2">
                    {
                        !isPartnerData && !isProgramData ?
                        <div className="esp-dashboard-card conv-text-center"
                            title='Displays the Count of First Time users where mobile number is mandatory.'
                        >
                            <label className="esp-box-header-title">No of FTU's</label>
                                <h5 className="esp-count-text"> {countData.first_time_users || 0} </h5>
                                <div style={{ clear: "both" }}></div>
                            </div>
                            :
                            ""
                    }
                </div>

                <div className="col-2">
                    {
                        !isPartnerData && !isProgramData ?
                        <div className="esp-dashboard-card conv-text-center" 
                        title='Displays the Count of Engaged users where mobile number is mandatory'
                            >
                                <label className="esp-box-header-title">No of EU's</label>
                                <h5 className="esp-count-text"> {countData.engaged_users && countData.engaged_users || 0} </h5>
                                <div style={{ clear: "both" }}></div>
                            </div>
                            :
                            ""
                    }
                </div>

                <div className="col-2">
                    <Button className="esp-inline-button ml-2" style={{
                            marginBottom: "15px"
                        }} onClick={handleFilterClick}>
                        <img
                            alt=""
                            src={ic_filter}
                            height={"15px"}
                            width={"15px"}
                            className="conv-mr10"
                        />
                        Filter By</Button>
                        <Button className="esp-inline-button ml-2" style={{
                            marginBottom: "15px"
                        }} onClick={handleClearClick}>
                        Clear filter</Button>
                </div>
                

            </div>

            <a onClick={goToProgramManagerDashboard} className="con-cursor-pointer"
                style={{
                    color: "#78417C",
                    position: 'absolute',
                    right: 24,
                    zIndex: 1
                }}>
                {isProgramManagerDashboard
                    ?
                    <span className='text-hover'>Go Back to Reports</span>
                    :
                    <span className='text-hover'>Program Manager Dashboard</span>
                }
            </a>

            <Modal isOpen={newModal}>
                <ModalContent className="EngagedDashboard-filter-modal">
                    <div className="modal-header">
                        <span className="modal-title">Filter Date Wise</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openFilterModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        <br />
                        <div className="row">
                            <div className="col-6 spled-container conv-zindex">
                                <div className="width-100">
                                    <ReactDatePicker
                                        dateFormat="dd/MM/yyyy"
                                        selected={fromDate}
                                        onChange={(date) => ondatechange("fromDate", date)}
                                        placeholderText="From Date"
                                        minDate={new Date("01-01-2013")}
                                    />
                                </div>
                            </div>

                            <div className="col-6 spled-container conv-zindex">
                                <div className="width-100">
                                    <ReactDatePicker
                                        dateFormat="dd/MM/yyyy"
                                        selected={toDate}
                                        onChange={(date) => ondatechange("toDate", date)}
                                        placeholderText="To Date"
                                        maxDate={new Date()}
                                    />
                                </div>
                            </div>
                        </div>
                        <br />
                        {
                            !isProgramManagerDashboard && isDateSelected && 
                            <div className="row">
                            <div className="offset-3 col-6 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={mergedResourceNames.map((program) => ({
                                            label: program,
                                            value: program,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select programs"
                                        value={selectedOptionsProgram}
                                        onChange={handleSelectProgram}
                                    />
                                </div>
                            </div>
                        </div>
                         } 
                        <br />
                        <div className='row d-flex justify-content-center align-items-center'>
                            <div className="offset-1 col-5">
                                <Button className="esp-inline-button" onClick={handleSearchClick}>Search</Button>
                            </div>
                            <div className="col-5">
                                <Button className="esp-inline-button" onClick={handleFilterByModalClearClick}>Clear</Button>
                            </div>
                            {/* <div className="col-4"></div> */}
                        </div>

                    </div>
                </ModalContent>
            </Modal>


            {/* Source and Medium filter Model */}

            <Modal isOpen={sourceModel}>
                <ModalContent className="EngagedDashboard-filter-modal">
                    <div className="modal-header">
                        <span className="modal-title">Filter</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openSourceModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        <br />
                        <div className="row">
                            <div className="col-6 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={sourceListData.map((partner) => ({
                                            label: partner,
                                            value: partner,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select Source"
                                        value={selectedOptionsSource}
                                        onChange={handleSelectSource}
                                    />
                                </div>
                            </div>
                            <div className="col-6 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={mediumListData.map((program) => ({
                                            label: program,
                                            value: program,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select medium"
                                        value={selectedOptionsMedium}
                                        onChange={handleSelectMedium}
                                    />
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='row d-flex justify-content-center align-items-center'>
                            <div className="col-5">
                                <Button className="esp-inline-button" onClick={handleSourceFilterSearchClick}>Search</Button>
                            </div>
                            <div className="offset-1 col-5">
                                <Button className="esp-inline-button" onClick={handleFtuSourceFilterClearClick}>Clear</Button>
                            </div>
                            {/* <div className="col-4"></div> */}
                        </div>

                    </div>
                </ModalContent>
            </Modal>

            {/* Engaged user Source Medium Filter Modal */}

            <Modal isOpen={sourceModelEu}>
                <ModalContent className="EngagedDashboard-filter-modal">
                    <div className="modal-header">
                        <span className="modal-title">Filter</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openSourceModalisFalseEu}
                        />
                    </div>

                    <div className="modal-body">
                        <br />
                        <div className="row">
                            <div className="col-6 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={sourceListDataEu.map((partner) => ({
                                            label: partner,
                                            value: partner,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select Source"
                                        value={selectedOptionsSourceEu}
                                        onChange={handleSelectSourceEu}
                                    />
                                </div>
                            </div>
                            <div className="col-6 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={mediumListDataEu.map((program) => ({
                                            label: program,
                                            value: program,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select medium"
                                        value={selectedOptionsMediumEu}
                                        onChange={handleSelectMediumEu}
                                    />
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='row d-flex justify-content-center align-items-center'>
                            <div className="offset-1 col-5">
                                <Button className="esp-inline-button" onClick={handleEuSourceFilterClearClick}>Clear</Button>
                            </div>
                            <div className="col-5">
                                <Button className="esp-inline-button" onClick={handleSourceFilterSearchClickEu}>Search</Button>
                            </div>
                            {/* <div className="col-4"></div> */}
                        </div>

                    </div>
                </ModalContent>
            </Modal>

            {/* Ftu Partner Filter Modal */}

            <Modal isOpen={ftuPartnerModal}>
                <ModalContent className="EngagedDashboard-filter-modal">
                    <div className="modal-header">
                        <span className="modal-title">Filter</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openFtuPartnerModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        <br />
                        <div className="row">
                            <div className="col-8 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={ftuPartnerListData.map((partner) => ({
                                            label: partner,
                                            value: partner,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select Partner"
                                        value={selectedOptionsFtuPartner}
                                        onChange={handleFtuPartnerSelect}
                                    />
                                </div>
                            </div>
                            <div className="col-4 spled-container">
                                <div className="width-100">
                                <Button className="esp-inline-button" onClick={handleFtuFilterSearchClick}>Search</Button>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='row d-flex justify-content-center align-items-center'>
                        <div className='col-4'></div>
                            <div className="col-4">
                            <Button className="esp-inline-button" onClick={handleFtuPartnerFilterClearClick}>Clear</Button>
                            </div>
                            <div className='col-4'></div>
                            {/* <div className="col-4"></div> */}
                        </div>

                    </div>
                </ModalContent>
            </Modal>

            {/* Eu Partner Filter Modal */}

            <Modal isOpen={euPartnerModal}>
                <ModalContent className="EngagedDashboard-filter-modal">
                    <div className="modal-header">
                        <span className="modal-title">Filter</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openEuPartnerModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        <br />
                        <div className="row">
                            <div className="col-8 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={EuPartnerListData.map((partner) => ({
                                            label: partner,
                                            value: partner,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select Partner"
                                        value={selectedOptionsEuPartner}
                                        onChange={handleEuPartnerSelect}
                                    />
                                </div>
                            </div>
                            <div className="col-4 spled-container">
                                <div className="width-100">
                                    <Button className="esp-inline-button" onClick={handleEuPartnerFilterClearClick}>Clear</Button>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='row d-flex justify-content-center align-items-center'>
                        <div className='col-4'></div>
                            <div className="col-4">
                                <Button className="esp-inline-button" onClick={handleEuFilterSearchClick}>Search</Button>
                            </div>
                            <div className='col-4'></div>
                            {/* <div className="col-4"></div> */}
                        </div>

                    </div>
                </ModalContent>
            </Modal>

            {/* Ftu Resource Filter Modal */}

            <Modal isOpen={ftuResourceModal}>
                <ModalContent className="EngagedDashboard-filter-modal">
                    <div className="modal-header">
                        <span className="modal-title">Filter</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openFtuResourceModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        <br />
                        <div className="row">
                            <div className="col-12 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={ftuResourceListData.map((partner) => ({
                                            label: partner,
                                            value: partner,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select Resource"
                                        value={selectedOptionsFtuResource}
                                        onChange={handleFtuResourceSelect}
                                    />
                                </div>
                            </div>
                            {/* <div className="col-4 spled-container">
                                <div className="width-100">
                                    <Button className="esp-inline-button" onClick={handleFtuResourceFilterClearClick}>Clear</Button>
                                </div>
                            </div> */}
                        </div>
                        <br />
                        <div className='row d-flex justify-content-center align-items-center'>
                        <div className='offset-1 col-4'>
                        <Button className="esp-inline-button" onClick={handleFtuResourceFilterClearClick}>Clear</Button>
                        </div>
                            <div className="offset-1 col-4">
                                <Button className="esp-inline-button" onClick={handleFtuResourceFilterSearchClick}>Search</Button>
                            </div>
                            {/* <div className='col-4'></div> */}
                            {/* <div className="col-4"></div> */}
                        </div>

                    </div>
                </ModalContent>
            </Modal>

            {/* Eu Resource Filter Modal */}

            <Modal isOpen={euResourceModal}>
                <ModalContent className="EngagedDashboard-filter-modal">
                    <div className="modal-header">
                        <span className="modal-title">Filter</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openEuResourceModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        <br />
                        <div className="row">
                            <div className="col-8 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={EuResourceListData.map((partner) => ({
                                            label: partner,
                                            value: partner,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select Resource"
                                        value={selectedOptionsEuResource}
                                        onChange={handleEuResourceSelect}
                                    />
                                </div>
                            </div>
                            <div className="col-4 spled-container">
                                <div className="width-100">
                                    <Button className="esp-inline-button" onClick={handleEuResourceFilterClearClick}>Clear</Button>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='row d-flex justify-content-center align-items-center'>
                        <div className='col-4'></div>
                            <div className="col-4">
                                <Button className="esp-inline-button" onClick={handleEuResourceFilterSearchClick}>Search</Button>
                            </div>
                            <div className='col-4'></div>
                            {/* <div className="col-4"></div> */}
                        </div>

                    </div>
                </ModalContent>
            </Modal>

            {/* Ftu Program Filter Modal */}

            <Modal isOpen={ftuProgramModal}>
                <ModalContent className="EngagedDashboard-filter-modal">
                    <div className="modal-header">
                        <span className="modal-title">Filter</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openFtuProgramModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        <br />
                        <div className="row">
                            <div className="col-8 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={ftuProgramListData.map((partner) => ({
                                            label: partner,
                                            value: partner,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select Program"
                                        value={selectedOptionsFtuProgram}
                                        onChange={handleFtuProgramSelect}
                                    />
                                </div>
                            </div>
                            <div className="col-4 spled-container">
                                <div className="width-100">
                                    <Button className="esp-inline-button" onClick={handleFtuProgramFilterClearClick}>Clear</Button>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='row d-flex justify-content-center align-items-center'>
                        <div className='col-4'></div>
                            <div className="col-4">
                                <Button className="esp-inline-button" onClick={handleFtuProgramFilterSearchClick}>Search</Button>
                            </div>
                            <div className='col-4'></div>
                            {/* <div className="col-4"></div> */}
                        </div>

                    </div>
                </ModalContent>
            </Modal>

            {/* Eu Program Filter Modal */}

            <Modal isOpen={euProgramModal}>
                <ModalContent className="EngagedDashboard-filter-modal">
                    <div className="modal-header">
                        <span className="modal-title">Filter</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openEuProgramModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        <br />
                        <div className="row">
                            <div className="col-8 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={EuProgramListData.map((partner) => ({
                                            label: partner,
                                            value: partner,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select Program"
                                        value={selectedOptionsEuProgram}
                                        onChange={handleEuProgramSelect}
                                    />
                                </div>
                            </div>
                            <div className="col-4 spled-container">
                                <div className="width-100">
                                    <Button className="esp-inline-button" onClick={handleEuProgramFilterClearClick}>Clear</Button>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='row d-flex justify-content-center align-items-center'>
                        <div className='col-4'></div>
                            <div className="col-4">
                                <Button className="esp-inline-button" onClick={handleEuProgramFilterSearchClick}>Search</Button>
                            </div>
                            <div className='col-4'></div>
                            {/* <div className="col-4"></div> */}
                        </div>

                    </div>
                </ModalContent>
            </Modal>

            {isProgramData && isPartnerData ?
                <div>
                    <div className="row">
                        <div className='col-12'>
                            <PartnerDataTable
                                data={partnerTableData} />
                        </div>
                        {programTableData.map((item) => {
                                let partnerNames = item.partnerData.reduce((uniqueNames, row) => {
                                      if (row.sEntryPoint && !uniqueNames.includes(row.sEntryPoint)) {
                                        uniqueNames.push(row.sEntryPoint);
                                      }
                                      return uniqueNames;
                                    }, [])

                                return (
                                    <div className='col-6 mt-3'>
                                    <DynamicProgramTable
                                        key={item.sPackageTitle}
                                        programName={item.sPackageTitle}
                                        partnerData={item.partnerData}
                                        partnerNames={partnerNames}
                                    />
                                </div>
                                )
                            })}
                        
                    </div>

                </div>
                :
                isProgramData ?
                    <div className="row">
                        {
                            programTableData.length > 0 && programTableData[0] != "" ?
                            programTableData.map((item) => {
                                let partnerNames = item.partnerData.reduce((uniqueNames, row) => {
                                      if (row.sEntryPoint && !uniqueNames.includes(row.sEntryPoint)) {
                                        uniqueNames.push(row.sEntryPoint);
                                      }
                                      return uniqueNames;
                                    }, [])

                                return (
                                    <div className='col-6 mt-3'>
                                    <DynamicProgramTable
                                        key={item.sPackageTitle}
                                        programName={item.sPackageTitle}
                                        partnerData={item.partnerData}
                                        partnerNames={partnerNames}
                                    />
                                </div>
                                )
                            })
                            :
                            programTableData.length > 0 && programTableData[0] === "" ?
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "65vh", width: "100%" }}>
                                        <div style={{ maxWidth: "500px", textAlign: "center" }}>
                                            No Data Found for Selected Programs
                                        </div>
                                    </div>
                            :
                            <Spinner className="center-screen"/>
                        }
                        {/* {programTableData.map((item) => (
                            <div className='col-6'>
                                <DynamicProgramTable
                                    key={item.sPackageTitle}
                                    programName={item.sPackageTitle}
                                    partnerData={item.partnerData}
                                />
                            </div>
                        ))} */}
                    </div>
                    :
                    isPartnerData ?
                        <div className='row'>
                            <div className='col-12'>
                                <PartnerDataTable
                                    data={partnerTableData} />
                            </div>

                        </div>
                        :
                        isProgramManagerDashboard ?
                            <div className="row mt-1">
                                <div className="col-12">
                                    <ProgramManagerHome
                                        fromDate={fromDate}
                                        toDate={toDate}
                                        setPartnerDataProgramManager={setPartnerDataProgramManager}
                                        getResourceDataForSelectedPartner={getResourceDataForSelectedPartner}
                                        getProgramManagerData={getProgramManagerData}
                                        resourceDataSelectedPartner={resourceDataSelectedPartner}
                                        setResourceDataSelectedPartner={setResourceDataSelectedPartner}
                                        partnerDataProgramManager={partnerDataProgramManager}
                                        selectedProgramManager={selectedProgramManager}
                                        setSelectedProgramManager={setSelectedProgramManager}
                                        setSelectedPartnerName={setSelectedPartnerName}
                                        selectedPartnerName={selectedPartnerName}
                                        getProgramDataforManager={getProgramDataforManager}
                                        programDataManager={programDataManager}
                                        setProgramDataManager={setProgramDataManager}
                                        getPartnerDataForSelectedProgram={getPartnerDataForSelectedProgram}
                                        partnerDataForSelectedProgram={partnerDataForSelectedProgram}
                                        setSelectedProgramName={setSelectedProgramName}
                                        selectedProgramName={selectedProgramName}
                                    />
                                </div>
                            </div>
                            :
                        <div>
                            <div className="row">
                                {/* <div className="col-6">
                                    <FirstTimeAnnualTurnover data={firstTimeAnnualTurnoverData} />
                                </div> */}
                                <div className="col-12">
                                    {/* <EngagedAnnualTurnover data={engagedAnnualTurnoverData} /> */}
                                    <MergedPartnerTable firstTimeData={firstTimePartnerData} engagedData={engagedPartnerData} selectedOptionsMergedPartner={selectedOptionsMergedPartner} setSelectedOptionsMergedPartner={setSelectedOptionsMergedPartner}/>
                                </div>
                                {/* <div className="col-6">
                                    <TotalFirstTimeChart data={firstTimeChartData} />
                                </div> */}
                            </div>

                            <div className="row mt-3">
                                {/* <div className="col-6">
                                    <FirstTimePartner handleFilterClick={handleFtuPartnerModalClick} data={firstTimePartnerData} />
                                </div> */}
                                <div className="col-12">
                                    {/* <EngagedPartner handleFilterClick={handleEuPartnerModalClick} data={engagedPartnerData} /> */}
                                    <MergedResourceTable firstTimeData={ftuGridData} engagedData={euGridData} selectedOptionsMergedResource={selectedOptionsMergedResource} setSelectedOptionsMergedResource={setSelectedOptionsMergedResource} />                                </div>
                                {/* <div className="col-4">
                                    <TotalEngagedUserChart data={engagedChartData} />
                                </div> */}
                            </div>

                            <div className="row mt-3">
                                {/* <div className="col-6">
                                    <FTUGrid handleFilterClick={handleFtuResourceModalClick} data={ftuGridData} />
                                </div> */}
                                <div className="col-12">
                                    {/* <EUGrid handleFilterClick={handleEuResourceModalClick} data={euGridData} /> */}
                                    <MergedSourceMediumTable firstTimeData={ftuSourceAndMediumData} engagedData={engagedSourceAndMediumData} selectedOptionsMergedSourceMedium={selectedOptionsMergedSourceMedium} setSelectedOptionsMergedSourceMedium={setSelectedOptionsMergedSourceMedium} selectedOptionsMergedSourceMediumEu={selectedOptionsMergedSourceMediumEu} setSelectedOptionsMergedSourceMediumEu={setSelectedOptionsMergedSourceMediumEu}/>
                                </div>
                                {/* <div className="col-4">
                                    <TotalResourceAwailed data={resourceAwailedChartData} />
                                </div> */}
                            </div>

                            <div className="row mt-3">
                                {/* <div className="col-6">
                                    <FTUSourceAndMediumGrid handleFilterClick={handleSourceModelClick} data={ftuSourceAndMediumData} />
                                </div> */}
                                <div className="col-12">
                                    {/* <EUSourceAndMedimGrid handleFilterClick={handleSourceModelClickEu} data={engagedSourceAndMediumData} /> */}
                                    <MergedProgramResourceTable firstTimeData={firstTimeProgramResourceData} engagedData={engagedProgramResourceData} selectedOptionsMergedProgramResource={selectedOptionsMergedProgramResource} setSelectedOptionsMergedProgramResource={setSelectedOptionsMergedProgramResource} selectedOptionsMergedProgramResourceEu={selectedOptionsMergedProgramResourceEu} setSelectedOptionsMergedProgramResourceEu={setSelectedOptionsMergedProgramResourceEu} />
                                </div>
                            </div>

                            <div className="row mt-3 mb-3">
                                {/* <div className="col-6">
                                    <FirstTimeProgram handleFilterClick={handleFtuProgramModalClick} data={firstTimeProgramData} />
                                </div> */}
                                <div className="col-12">
                                    {/* <EngagedUserProgram handleFilterClick={handleEuProgramModalClick} data={engagedUserProgramData} /> */}
                                    {/* <MergedProgramTable firstTimeData={firstTimeProgramData} engagedData={engagedUserProgramData} selectedOptionsMergedProgram={selectedOptionsMergedProgram} setSelectedOptionsMergedProgram={setSelectedOptionsMergedProgram}  /> */}
                                    <MergedPartnerResourceTable firstTimeData={firstTimePartnerResourceData} engagedData={engagedPartnerResourceData} selectedOptionsMergedPartnerResource={selectedOptionsMergedPartnerResource} setSelectedOptionsMergedPartnerResource={setSelectedOptionsMergedPartnerResource} selectedOptionsMergedPartnerResourceEu={selectedOptionsMergedPartnerResourceEu} setSelectedOptionsMergedPartnerResourceEu={setSelectedOptionsMergedPartnerResourceEu} />
                                </div>
                            </div>

                            <div className="row mt-3 mb-3">
                                <div className="col-12">
                                    {/* <EngagedUserProgram handleFilterClick={handleEuProgramModalClick} data={engagedUserProgramData} /> */}
                                    <MergedTurnoverTable firstTimeData={firstTimeAnnualTurnoverData} engagedData={engagedAnnualTurnoverData}/>
                                </div>
                            </div>

                            {/* <div className="row mt-3 mb-3">
                                <div className="col-6">
                                    <MonthlyDataGrid data={monthwiseData} />
                                </div>
                                <div className="col-6">
                                    <MonthlyUserChart data={monthwiseData} />
                                </div>
                            </div> */}
                        </div>
            }




        </div>
    )
}

export default NewAndEngagedUserHome
